/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfUserDataDto } from '../models/platform-api-result-of-user-data-dto';
import { getUserdataMine } from '../fn/user-data/get-userdata-mine';
import { GetUserdataMine$Params } from '../fn/user-data/get-userdata-mine';
import { postUserdataActionUpdateAppSettings } from '../fn/user-data/post-userdata-action-update-app-settings';
import { PostUserdataActionUpdateAppSettings$Params } from '../fn/user-data/post-userdata-action-update-app-settings';
import { postUserdataActionUpdateAppState } from '../fn/user-data/post-userdata-action-update-app-state';
import { PostUserdataActionUpdateAppState$Params } from '../fn/user-data/post-userdata-action-update-app-state';

@Injectable({ providedIn: 'root' })
export class PlatformUserDataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserdataMine()` */
  static readonly GetUserdataMinePath = '/api/userdata/mine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserdataMine()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserdataMine$Response(params?: GetUserdataMine$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserDataDto>> {
    return getUserdataMine(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserdataMine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserdataMine(params?: GetUserdataMine$Params, context?: HttpContext): Observable<PlatformApiResultOfUserDataDto> {
    return this.getUserdataMine$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserDataDto>): PlatformApiResultOfUserDataDto => r.body)
    );
  }

  /** Path part for operation `postUserdataActionUpdateAppSettings()` */
  static readonly PostUserdataActionUpdateAppSettingsPath = '/api/userdata/action/update-app-settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserdataActionUpdateAppSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserdataActionUpdateAppSettings$Response(params: PostUserdataActionUpdateAppSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserDataDto>> {
    return postUserdataActionUpdateAppSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserdataActionUpdateAppSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserdataActionUpdateAppSettings(params: PostUserdataActionUpdateAppSettings$Params, context?: HttpContext): Observable<PlatformApiResultOfUserDataDto> {
    return this.postUserdataActionUpdateAppSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserDataDto>): PlatformApiResultOfUserDataDto => r.body)
    );
  }

  /** Path part for operation `postUserdataActionUpdateAppState()` */
  static readonly PostUserdataActionUpdateAppStatePath = '/api/userdata/action/update-app-state';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserdataActionUpdateAppState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserdataActionUpdateAppState$Response(params: PostUserdataActionUpdateAppState$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserDataDto>> {
    return postUserdataActionUpdateAppState(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserdataActionUpdateAppState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserdataActionUpdateAppState(params: PostUserdataActionUpdateAppState$Params, context?: HttpContext): Observable<PlatformApiResultOfUserDataDto> {
    return this.postUserdataActionUpdateAppState$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserDataDto>): PlatformApiResultOfUserDataDto => r.body)
    );
  }

}
